import { render, staticRenderFns } from "./SignupHealthCare.vue?vue&type=template&id=40471a16"
import script from "./SignupHealthCare.vue?vue&type=script&lang=js"
export * from "./SignupHealthCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports